/**
 * @Date:   2019-10-21T16:01:15+05:30
 * @Last modified time: 2019-10-24T20:25:03+05:30
 */

import { put, takeEvery, takeLatest } from "redux-saga/effects";
import { hideProcessingSpinner, resetForm, resetSavedStates } from "./form";
import { setInspectedReferral } from "./referralInspect";
import { enqueueSnackbar } from "./notifiers";
import { openCardDetailModal } from "./cardDetailModal";
import { closeDialog, resetReferralForm } from "./createDialog";
import _ from "lodash";
import { closeDetail } from "./mDetail";
import { DONE_STATE } from "../../constants/referrals";
import { updateReferralInArray } from "../../utils/arrays";

// Actions
const CHANGE_REFERRAL_STATE = "hermes/referrals-sent/CHANGE_REFERRAL_STATE";
const CHANGE_REFERRAL_STATE_SUCCESS =
  "hermes/referrals-sent/CHANGE_REFERRAL_STATE_SUCCESS";
const CHANGE_REFERRAL_STATE_FAILURE =
  "hermes/referrals-sent/CHANGE_REFERRAL_STATE_FAILURE";
const CREATE_REFERRAL = "hermes/referrals-sent/CREATE_REFERRAL";
const CREATE_REFERRAL_SUCCESS = "hermes/referrals-sent/CREATE_REFERRAL_SUCCESS";
const CREATE_REFERRAL_FAILURE = "hermes/referrals-sent/CREATE_REFERRAL_FAILURE";
const CLONE_REFERRAL_SUCCESS = "hermes/referrals-sent/CLONE_REFERRAL_SUCCESS";
const TOGGLE_REFERRAL_FLAG_SUCCESS =
  "hermes/referrals-sent/TOGGLE_REFERRAL_FLAG_SUCCESS";
const TOGGLE_REFERRAL_FLAG_RESET =
  "hermes/referrals-sent/TOGGLE_REFERRAL_FLAG_RESET";
export const UPDATE_SENT_REFERRAL_PATIENT =
  "hermes/referrals-sent/UPDATE_SENT_REFERRAL_PATIENT";
const EDIT_REFERRAL_SUCCESS = "hermes/referrals-sent/EDIT_REFERRAL_SUCCESS";
const GET_SENT_REFERRALS_SUCCESS =
  "hermes/referrals-sent/GET_SENT_REFERRALS_SUCCESS";
const GET_SENT_REFERRAL = "hermes/referrals-sent/GET_SENT_REFERRAL";
const GET_SENT_REFERRAL_SUCCESS =
  "hermes/referrals-sent/GET_SENT_REFERRAL_SUCCESS";
const SELECT_ASSIGNEE = "hermes/referrals-sent/SELECT_ASSIGNEE";
const REFERRAL_REDIRECT_URL = "hermes/referrals-sent/REFERRAL_REDIRECT_URL";
const LOADING_START = "hermes/referrals-sent/LOADING_START";
const LOADING_FINISH = "hermes/referrals-sent/LOADING_FINISH";
const RESET_REFRESH_FLAG = "hermes/referrals-sent/RESET_REFRESH_FLAG";

const initialState = {
  list: [],
  details: [],
  loaded: false,
  redirectUrl: null,
  referralFlagToggledId: null,
  refreshReferralSearch: false,
  loading: false,
};

export function determineIfAbleToFlag(referral) {
  return (
    referral &&
    referral.status !== "Done" &&
    referral.status !== "Closed" &&
    referral.status !== "Declined"
  );
}

export function determineIfAbleToClone(referral) {
  return referral && referral.type === "SENT";
}

export function determineIfAbleToCancel(referral) {
  return (
    referral &&
    referral.type === "SENT" &&
    referral.status !== "Consulted" &&
    referral.status !== "Declined" &&
    referral.status !== "Closed" &&
    referral.status !== "Done"
  );
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SENT_REFERRALS_SUCCESS:
      return {
        ...state,
        list: action.response,
        loaded: true,
      };
    case GET_SENT_REFERRAL_SUCCESS:
      const getSentDetails = state.details;
      const detailExists = state.details.findIndex(
        (referral) =>
          action.processInstanceId === referral.id ||
          action.response?.id === referral.id
      );
      if (detailExists !== -1) {
        getSentDetails[detailExists] = action.response;
      } else {
        getSentDetails.push(action.response);
      }
      return {
        ...state,
        details: getSentDetails,
      };
    case CHANGE_REFERRAL_STATE:
      let updatedDetails = [];
      const referralDetailIndex = state.details.findIndex(
        (referral) => action.referralId === referral.id
      );

      if (referralDetailIndex !== -1) {
        updatedDetails = [...state.details];
        updatedDetails[referralDetailIndex] = {
          ...updatedDetails[referralDetailIndex],
          status: action.targetState,
        };
      }

      return {
        ...state,
        list:
          state.list.length > 0
            ? updateReferralInArray(state.list, action.referralId, {
                status: action.targetState,
              })
            : state.list,
        details: updatedDetails,
      };
    case CHANGE_REFERRAL_STATE_SUCCESS:
      let successUpdatedDetails = state.details;
      let referralActionComment = "";
      const referralDetailSuccessIndex = state.details.findIndex(
        (referral) => action.referral?.id === referral.id
      );

      if (referralDetailSuccessIndex !== -1) {
        successUpdatedDetails = [...state.details];
        successUpdatedDetails[referralDetailSuccessIndex] = {
          ...successUpdatedDetails[referralDetailSuccessIndex],
          status: action.newStatus,
        };
      }

      if (action.referral.status === DONE_STATE && action.referral.comment) {
        referralActionComment = action.referral.comment;
      }

      return {
        ...state,
        referralActionComment,
        referralStatus: action.newStatus,
        list:
          state.list.length > 0
            ? updateReferralInArray(
                state.list,
                action.referral.id,
                action.referral
              )
            : state.list,
        details: successUpdatedDetails,
        refreshReferralSearch: true,
      };
    case CHANGE_REFERRAL_STATE_FAILURE:
      const changeStateFailDetail = state.details;
      const changeStateFailDetailExists = state.details.findIndex(
        (referral) =>
          action.processInstanceId === referral.id ||
          action.referral?.id === referral.id
      );
      if (changeStateFailDetailExists !== -1) {
        changeStateFailDetail[changeStateFailDetailExists] = action.referral;
      } else {
        changeStateFailDetail.push(action.referral);
      }
      return {
        ...state,
        list: [
          ...state.list.map((referral) => {
            if (action.referral.id === referral.id) {
              return action.referral;
            }
            return referral;
          }),
        ],
        details: changeStateFailDetail,
      };
    case UPDATE_SENT_REFERRAL_PATIENT:
      return {
        ...state,
        details: [
          ...state.details.map((referral) =>
            referral.patientId === action.patient.id
              ? { ...referral, patient: action.patient }
              : { ...referral }
          ),
        ],
      };
    case EDIT_REFERRAL_SUCCESS:
      const editDetail = state.details;
      const editDetailExists = state.details.findIndex(
        (referral) =>
          action.processInstanceId === referral.id ||
          action.referral?.id === referral.id
      );
      if (editDetailExists !== -1) {
        editDetail[editDetailExists] = {
          ...(editDetail[editDetailExists].patientId ===
            action.referral.patientId && {
            patient: editDetail[editDetailExists].patient,
          }),
          ...action.referral,
        };
      } else {
        editDetail.push(action.referral);
      }
      return {
        ...state,
        list: state.list.map((ref) => {
          if (ref.id === action.referral.id) {
            return {
              ...(ref.patientId === action.referral.patientId && {
                patient: ref.patient,
              }),
              ...action.referral,
            };
          }
          return ref;
        }),
        details: editDetail,
      };
    case CREATE_REFERRAL_SUCCESS:
      const newReferral = {
        ...action,
        type: "SENT",
      };
      return {
        ...state,
        list: [...state.list, newReferral],
      };
    case CLONE_REFERRAL_SUCCESS:
      return {
        ...state,
        list: [...state.list, action.response],
      };
    case CREATE_REFERRAL_FAILURE:
      return {
        ...state,
      };
    case TOGGLE_REFERRAL_FLAG_SUCCESS: {
      const referralId = action.id;
      const newFlaggedState = action.flagged;

      // Update list referrals
      const updatedList = state.list.map((ref) =>
        ref.id === referralId ? { ...ref, flagged: newFlaggedState } : ref
      );

      // Update details referrals only if fullScreen is true
      const updatedDetails = action.fullScreen
        ? state.details.map((ref) =>
            ref.id === referralId ? { ...ref, flagged: newFlaggedState } : ref
          )
        : state.details;

      return {
        ...state,
        referralFlagToggledId: action.referralId,
        list: updatedList,
        details: updatedDetails,
      };
    }
    case TOGGLE_REFERRAL_FLAG_RESET:
      return {
        ...state,
        referralFlagToggledId: null,
      };
    case REFERRAL_REDIRECT_URL:
      return {
        ...state,
        redirectUrl: action.redirectUrl,
      };
    case LOADING_START:
      return {
        ...state,
        loading: true,
      };
    case LOADING_FINISH:
      return {
        ...state,
        loading: false,
      };
    case RESET_REFRESH_FLAG:
      return {
        ...state,
        refreshReferralSearch: false,
      };
    default:
      return state;
  }
}

// Action Creators

export function changeReferralState(referralId, targetState) {
  return {
    type: CHANGE_REFERRAL_STATE,
    referralId,
    targetState,
  };
}

export function changeReferralStatusSuccess(referral, newStatus) {
  return {
    type: CHANGE_REFERRAL_STATE_SUCCESS,
    referral,
    newStatus,
  };
}

export function fetchSentReferralsApollo(data) {
  return {
    type: GET_SENT_REFERRALS_SUCCESS,
    response: data,
  };
}

export function startApolloLoading() {
  return { type: LOADING_START };
}

export function finishApolloLoading() {
  return { type: LOADING_FINISH };
}

export function resetSentRefresh() {
  return { type: RESET_REFRESH_FLAG };
}

export function getSentReferral(referral, options = {}) {
  const { inspectReferral, cardDetail } = options;
  return {
    type: GET_SENT_REFERRAL,
    referral,
    inspectReferral,
    cardDetail,
  };
}

export function setSentReferralDetail(referral) {
  return {
    type: GET_SENT_REFERRAL_SUCCESS,
    response: referral,
  };
}

export function posCreateReferral(referral, isReceivedReferral, keepOpen) {
  return {
    type: CREATE_REFERRAL,
    referral,
    isReceivedReferral,
    keepOpen,
  };
}

export function cloneReferralSuccess(response) {
  return {
    type: CLONE_REFERRAL_SUCCESS,
    response,
  };
}

export function toggleSentReferralFlagSuccess(
  referralId,
  flagged,
  fullScreen = false
) {
  return {
    type: TOGGLE_REFERRAL_FLAG_SUCCESS,
    id: referralId,
    flagged: !flagged,
    referralId,
    fullScreen,
  };
}

export function resetSentReferralFlag() {
  return {
    type: TOGGLE_REFERRAL_FLAG_RESET,
  };
}

export function selectAssignee(referralId, displayableId, assignee) {
  return {
    type: SELECT_ASSIGNEE,
    referralId,
    displayableId,
    assignee,
  };
}

// Sagas

function* handleGetSentReferral(action) {
  try {
    const response = action?.referral;

    yield put({
      response: response,
      type: GET_SENT_REFERRAL_SUCCESS,
    });
    if (action.inspectReferral) {
      yield put(setInspectedReferral(response));
    }
    if (action.cardDetail) {
      yield put(openCardDetailModal(response));
    }
  } catch (e) {
    if (action.inspectReferral) {
      yield put(setInspectedReferral(null));
    }
    yield put(
      enqueueSnackbar({
        message: `Unable to fetch requested referral.`,
        options: {
          variant: "error",
        },
      })
    );
  }
}

function* handlePosCreateReferral(action) {
  try {
    const newReferral = action.referral;
    yield put(closeDetail());
    yield put({ ...newReferral, type: CREATE_REFERRAL_SUCCESS });

    if (action.keepOpen) {
      let newUrl;
      if (action.isReceivedReferral) {
        // view detail for received
        newUrl = "/referrals/received/" + newReferral.id;
      } else {
        // view detail for sent
        newUrl = "/referrals/sent/" + newReferral.id;
      }
      // Immediately redirect without delay
      yield put({
        type: REFERRAL_REDIRECT_URL,
        redirectUrl: newUrl,
      });
    } else {
      yield put(closeDialog());
      yield put(resetReferralForm());
      yield put(hideProcessingSpinner());
      yield put(resetForm());
      yield put(resetSavedStates());
    }
  } catch (e) {
    console.error(e);
    let errorLogging = {};
    if (!_.includes(e.message, "401")) {
      errorLogging = { error: true, payload: e };
    }
    yield put(
      enqueueSnackbar({
        message: `Error creating referral.`,
        options: {
          variant: "error",
        },
      })
    );

    yield put(hideProcessingSpinner());
    yield put({ type: CREATE_REFERRAL_FAILURE, ...errorLogging });
  }
}

export function* getSentReferralSaga() {
  yield takeLatest(GET_SENT_REFERRAL, handleGetSentReferral);
}

export function* createSentReferralSaga() {
  yield takeEvery(CREATE_REFERRAL, handlePosCreateReferral);
}
